import React, { useState } from "react";
import axios from "axios";
import { Button, Col, Input, Row, Card, CardBody, CardTitle, CardHeader, FormGroup, Label } from "reactstrap";
import StlViewer from "./StlViewer";
import preview from "./Preview.jpg";
import DownloadIcon from '@mui/icons-material/Download';
const TubeGeneratorPage = () => {

    const API = "https://b5f6-106-51-84-190.ngrok-free.app/api";
    // const API = "http://localhost:5095/api";


    const [formData, setFormData] = useState({
        tubeLength: "",
        pitch: "",
        bendCount: "",
        tubeOD: "",
        tubeThickness: "",
        shellOffset: "",
        tubeGap: "",
        flowDirection: "",
    });

    const [result, setResult] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const generatePart = async () => {
        // Check if any required field is empty
        const requiredFields = [
            "tubeLength",
            "pitch",
            "bendCount",
            "tubeOD",
            "tubeThickness",
            "shellOffset",
            "tubeGap",
            "flowDirection",
        ];

        const hasEmpty = requiredFields.some(
            (field) => !formData[field] || formData[field].toString().trim() === ""
        );

        if (hasEmpty) {
            alert("Please fill all the details before generating.");
            return;
        }

        setLoading(true);

        try {
            const response = await axios.post(
                `${API}/Inventor/generate`,
                formData
            );

            setResult(response.data);
        } catch (err) {
            alert(err.response?.data?.error || "Something went wrong");
        }

        setLoading(false);
    };
    const isFormValid = Object.values({
        ...formData
    }).every(value => value !== "");

    const fields = [
        { key: "tubeLength", label: "Tube Length" },
        { key: "pitch", label: "Pitch" },
        { key: "bendCount", label: "Bend Count" },
        { key: "tubeOD", label: "Tube OD" },
        { key: "tubeThickness", label: "Tube Thickness" },
        { key: "shellOffset", label: "Shell Offset" },
        { key: "tubeGap", label: "Tube Gap" }
    ];


    return (
        <>
            <Row className="mt-3">
                {/* LEFT SIDE - INPUTS */}
                <Col xs="12" md="3">
                    <Card className="shadow-sm">
                        <CardBody>
                            <CardTitle tag="h5" className="mb-3">
                                Enter Tube Parameters
                            </CardTitle>

                            {fields.map((field, index) => {
                                const letter = String.fromCharCode(65 + index); // 65 = 'A'

                                return (
                                    <FormGroup floating className="mb-3" key={field.key}>
                                        <Input
                                            id={field.key}
                                            name={field.key}
                                            placeholder={field.label}
                                            value={formData[field.key]}
                                            onChange={handleChange}
                                            type="number"
                                        />
                                        <Label for={field.key}>
                                            {letter} = {field.label}
                                        </Label>
                                    </FormGroup>
                                );
                            })}




                            <FormGroup floating className="mb-3">
                                <select
                                    id="flowDirection"
                                    name="flowDirection"
                                    value={formData.flowDirection}
                                    onChange={handleChange}
                                    className="form-select"
                                    placeholder="Flow Direction"
                                >
                                    <option value=""></option>
                                    <option value="LeftInRightOut">Left In → Right Out</option>
                                    <option value="RightInLeftOut">Right In → Left Out</option>
                                    {/* <option value="LeftInLeftOut">Left In → Left Out</option>
    <option value="RightInRightOut">Right In → Right Out</option> */}
                                </select>

                                <Label for="flowDirection">Flow Direction</Label>
                            </FormGroup>


                            <Button
                                onClick={generatePart}
                                disabled={loading || !isFormValid}
                                color="primary"
                                block
                            >
                                {loading ? "Generating..." : "Generate"}
                            </Button>

                        </CardBody>
                    </Card>
                </Col>

                {/* RIGHT SIDE - VIEWER & DOWNLOAD */}
                <Col xs="12" md="9">
                    <Card className="shadow-sm">
                        <CardBody>
                            <div className="d-flex gap-3 align-items-center">
                            <CardTitle tag="h5">Output & Preview</CardTitle>{result && (
                                <div className="d-flex gap-3 p-3 align-items-center">
                                    <Button
                                        color="success"
                                        href={`${API}/Inventor/download/${result.id}`}
                                        target="_blank"
                                    >
                                        <DownloadIcon/> *IPT
                                    </Button>

                                    <Button
                                        color="primary"
                                        href={`${API}/Inventor/download/stl/${result.id}`}
                                        target="_blank"
                                    >
                                        <DownloadIcon/> *STL
                                    </Button>
                                </div>
                            )}
</div>
                            {!result ? (
                                <>
                                    <p className="text-muted mt-3">
                                        * Generated files will appear here after processing.
                                    </p>
                                    <img src={preview} alt="Preview" width="100%" height="auto" />

                                </>

                            ) : (
                                <Card className="mt-3">
                                    <CardHeader>3D Preview</CardHeader>

                                    <CardBody
                                        style={{
                                            height: "700px",
                                            padding: 0,
                                        }}
                                    >
                                        <StlViewer
                                            url={`${API}/Inventor/view/stl/${result.id}`}
                                            width="100%"
                                            height="100%"
                                        />
                                    </CardBody>                                  
                                </Card>
                            )}
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </>
    );
};

export default TubeGeneratorPage;
